import React from "react";
import { Container, Typography, Grid, Card, CardContent, Button } from "@mui/material";

const NRIPage: React.FC = () => {
    return (
        <Container maxWidth="lg" style={{ marginTop: "2rem" }}>
            <Typography variant="h3" align="center" gutterBottom>
                NRI 
            </Typography>
        </Container>
    );
};

export default NRIPage;